import { nanoid } from 'nanoid'
import React from 'react'
import { checkTextTranslation, checkTranslation, chooseFontColor, translate } from '../../utils/useful'
import SelectInput from './SelectInput'
import FixedView from '../FixedView'
import { colorPallets } from '../../variables/colors'

class ChartFieldInput extends React.Component {
    state = {
        choiceOption: [
            {}
        ],
        firtRow: { title: '', value: nanoid() }
    }


    componentDidMount() {
        if (!this.props.data || this.props.data.length == 0) {
            // this.addHandler()
        }


    }

    init = () => {

        // console.log("INIT")
        this.selectInput.init()
    }

    changeInputValue(value) {

        console.log(this.props.header.key)
        console.log(value)

        this.props.changeValue(this.props.header.key, value, this.props.extra)

    }

    addHandler = () => {
        let data = this.props.data
        if (!Array.isArray(data)) {
            data = []
        }
        data.push({ title: '', value: nanoid() })
        this.changeInputValue(data)

    }


    removeHandler = (index) => {
        let data = this.props.data
        let indexx = index
        // let y=data.index[indexx]
        // console.log('eeeeeeee', index);
        if (data.length < 1) {
            // alert('nooooo')
        } else {
            data.splice(index, 1)
            this.setState({ data })
        }
    }

    changeRowValue = (value, index) => {

        let data = this.props.data

        if (!Array.isArray(data)) {
            data = [{}]
        }
        // console.log(value)
        // console.log(index)

        data[index].title = value

        // console.log(data)
        this.changeInputValue(data)
    }


    changeValue = (key, value) => {
        let data = { ...this.props.data }
        if (!data) {
            data = {}
        }

        data[key] = value
        // console.log(key)
        // console.log(value)
        // console.log(data)
        this.changeInputValue(data)


        // console.log(value)
    }


    render() {


        let list = Array.isArray(this.props.data) ? this.props.data : [this.state.firtRow]

        return (
            <div className='pb-1'>
                {Array.isArray(list) && list.map((item, index) => {
                    return (
                        <div className="w-100 h-100 d-flex flex-column mb-2">
                            <div className="flexcb mt-1 " >
                                <div className="flexcc">
                                    <img draggable={false} src='/assets/icons/drag-and-drop.svg' height={14} className="builder-options-icon   mrd-1" />
                                </div>
                                <div className='py-1 px-2 w-100 flexc' style={{ border: "1.3px solid rgba(223, 222, 223, 1)", borderRadius: "5px" }}>

                                    {/* <div className="">
                                        <img draggable={false} src='/assets/icons/applets/database/image.svg' height={14} className="   mrd-3" />
                                    </div> */}
                                    {/* <button className='' onClick={() => this.addHandler()}>
                                        <p className='text-smaller text-semibold' style={{ color: '#007aff' }}>{translate("Sum")}</p>
                                    </button> */}

                                    <SelectInput ref={el => this.selectInput = el} fullData={this.props.fullData} data={this.props.data?.field} header={{ key: 'field', information: this.props.header?.information }} changeValue={this.changeValue} />
                                    {/* <input disabled={this.props.header.information.disabled} autoFocus={this.props.header.information.autoFocus} ref={el => this.input = el} type="multiplechoice" step="any" value={item.title != null ? checkTranslation(item.title) : ''} maxLength={this.props.header.information.maxLength} onChange={(e) => this.changeRowValue(e.target.value, index)} placeholder={checkTextTranslation(this.props.header.information.placeholder ?? '{{lang}}Option ...')} className="transpanet-input" /> */}


                                </div>
                                <div className="d-flex mld-2" style={{ gap: ".1em" }}>
                                    <img src="/images/remove-2.png" width={16} onClick={() => this.removeHandler(index)} alt="" />
                                </div>


                            </div>


                            <div>

                                {/* <div className='pld-5 mt-1 d-flex flex-column'>
                                    
                                </div> */}

                                <div className=' flexc mt-1 pld-5' style={{}}>

                                    <div className='flexc mrd-2'>
                                        <button className='br-20 flexcc  prd-3' ref={(el) => (this.textColorBut = el)} onClick={() => this.textColorView.showView()} style={{ border: '1px dashed #ccc', height: 22, }}>
                                            <div className='br-20 flexcc mrd-1' style={{ border: '1px solid #f0f0f0', height: 20, width: 20 }}>
                                                <div className='br-20' style={{ height: 18, width: 18, backgroundColor: 'rgb(88, 86, 214)' }}></div>
                                            </div>
                                            <img ref={(el) => (this.textColorBut = el)} onClick={() => this.textColorView.showView()} src='/assets/icons/builder/paint-bucket.png' height={14} className="builder-options-icon mrd-1  " />
                                            <p className='text-smaller text-semibold' style={{ color: '#666' }}>Solid</p>
                                        </button>
                                    </div>


                                    {/* <div className='br-20 flexcc mrd-2' style={{ border: '1px dashed #ccc', height: 22, width: 22 }}>
                                        <img  src='/assets/icons/builder/paint-bucket.png' height={14} className="builder-options-icon   " />
                                    </div> */}


                                    <div className='br-20 flexcc mrd-2' style={{ border: '1px dashed #ccc', height: 22, width: 22 }}>
                                        <img ref={(el) => (this.fontSizeBut = el)} onClick={() => this.fontSizeView.showView()} src='/assets/icons/builder/font-size.png' height={14} className="builder-options-icon   " />
                                    </div>


                                    <div className='br-20 flexcc mrd-2' style={{ border: '1px dashed #ccc', height: 22, width: 22 }}>
                                        <img ref={(el) => (this.textAlignBut = el)} onClick={() => this.fontSizeView.showView()} src='/assets/icons/builder/sticker.png' height={14} className="builder-options-icon " />
                                    </div>


                                    {/* <img onClick={(e) => { e.stopPropagation(); this.doRemoveElement(e, section,) }} src='/assets/icons/useful/trash-o.svg' height={14} className="builder-options-icon   " /> */}


                                    {/* <img ref={(el) => (this.fieldLabelBut = el)} onClick={() => this.textWeightView.showView()} src='/assets/icons/builder/tag.png' height={14} className="builder-options-icon   mrd-3" /> */}
                                    {/* <img ref={(el) => (this.fieldIconBut = el)} onClick={() => this.textWeightView.showView()} src='/assets/icons/builder/sticker.png' height={14} className="builder-options-icon   mrd-3" /> */}


                                    {/* <img ref={(el) => (this.changeVisiblityBut = el)} onClick={() => this.makeInvisible()} src='/assets/icons/builder/hide.png' height={14} className="builder-options-icon  mrd-3 " /> */}



                                    {/* <img src='/assets/icons/useful/row.png' height={14} className="builder-options-icon invert  mrd-2" />
                    <img src='/assets/icons/useful/column.png' height={14} className="builder-options-icon invert  mrd-2" /> */}

                                </div>
                            </div>
                        </div>
                    )
                })}

                <button className=' pld-5' onClick={() => this.addHandler()}>
                    <p className='text-smaller text-semibold' style={{ color: '#007aff' }}>+ {translate("Add Option")}</p>
                </button>



                <FixedView zIndex={10} ref={(el) => (this.textColorView = el)} nodeRef={this.textColorBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={300} width={300}   >
                    <div className="bg-white br-10  shadow-3 w-100" onClick={e => e.stopPropagation()}>
                        <div className="d-flex flex-column h-100" style={{}}   >


                            <div className='flexcb py-2 px-3' style={{ position: 'sticky', top: 0, borderBottom: '1px solid #f0f0f0', zIndex: 1, background: '#fff', borderRadius: '10px 10px 0px 0px' }}>
                                <button className="flexc mrd-3  " onClick={() => this.setData('textColor', null, this.textColorView)} >
                                    <p className="  text-bold" style={{ fontSize: 13, color: 'rgb(88, 86, 214)' }}>{translate("Pallete")}</p>
                                </button>

                                <button className="flexc mrd-3  " onClick={() => this.setData('textColor', null, this.textColorView)} >
                                    <p className="  text-semibold" style={{ fontSize: 13, color: 'rgb(104, 111, 125)' }}>{translate("Solid")}</p>
                                </button>

                                <button className="flexc mrd-3  " onClick={() => this.setData('textColor', null, this.textColorView)} >
                                    <p className="  text-semibold" style={{ fontSize: 13, color: 'rgb(104, 111, 125)' }}>{translate("Gradient")}</p>
                                </button>

                                <button className="flexc mrd-3  " onClick={() => this.setData('textColor', null, this.textColorView)} >
                                    <p className="  text-semibold" style={{ fontSize: 13, color: 'rgb(104, 111, 125)' }}>{translate("Conditional")}</p>
                                </button>


                            </div>


                            <div className="flexc  flex-wrap pb-2 px-3  flex-1">
                                <div className='h-100 sc-gray2 py-2' style={{ overflowY: "auto", maxHeight: 250 }}>
                                    {Object.values(colorPallets).map((pallet, index) => {
                                        return (
                                            <div className='mb-1'>
                                                <p className='mb-1 text-semibold ' style={{ fontSize: 12, color: 'rgb(104, 111, 125)' }}>{pallet.label}</p>
                                                <div className='flexc  flex-wrap'>
                                                    {pallet.colors.map((prop, index) => {
                                                        let color = prop
                                                        return (
                                                            <div className="color-picker-hover p-0 mrd-1 br-4 flexcc mb-1" style={{ padding: '2px' }}>
                                                                <button onClick={() => this.setData('textColor', color, this.textColorView)} className="flexcc" style={{ height: 24, width: 28 }}>
                                                                    <div className="br-4" style={{ background: color, height: '100%', width: '100%', border: chooseFontColor(color) != '#fff' ? '1px solid #f6f6f6' : '1px solid transparent' }}>

                                                                    </div>
                                                                </button>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>

                            </div>

                            <div className='flexc justify-content-end' style={{ borderTop: '1px solid #eee' }}>

                                <button className="flexc mb-1 px-3 py-1 " onClick={() => this.setData('textColor', null, this.textColorView)} >
                                    {/* <img src="/assets/icons/builder/color-palette.png" height={12} /> */}
                                    <p className="text-smaller px-1 text-bold" style={{ color: "rgb(88, 86, 214)" }}>{translate("Clear Color")}</p>
                                </button>

                                {/* <div className="w-100 mt-1 px-1 py-1" >
                                    <button className="pt-2 pb-1 " >
                                        <p className="text-smaller text-semibold">{translate("Conditional Formatting")}</p>
                                    </button>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </FixedView>

            </div>
        );
    }
}

export default ChartFieldInput;